var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyBid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.125,
    cy: 14,
    r: 14,
    fill: "#DCEFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52141 13.5296L9.17871 14.1445L14.2049 16.9455L14.5476 16.3306L9.52141 13.5296Z",
    fill: "#004C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9004 13.8919L16.8584 12.1719L21.6664 14.8519C21.9764 15.0259 22.0884 15.4179 21.9164 15.7279L21.5844 16.3219C21.4104 16.6319 21.0184 16.7439 20.7084 16.5719L15.9004 13.8919Z",
    fill: "#004C3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3299 7.52418L10.0693 13.375L14.388 15.7817L17.6485 9.93088L13.3299 7.52418Z",
    fill: "#004C3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5146 6.36335L13.1729 6.97656L18.1991 9.77757L18.5408 9.16436L13.5146 6.36335Z",
    fill: "#004C3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8976 20.4693H6.85156V17.7933H7.83556V16.7173H12.1596L8.09356 14.4513L9.21556 12.4393L9.56956 12.6353L12.4396 7.48334L12.0876 7.28734L13.2076 5.27734L19.6316 8.85734L18.5116 10.8673L18.1576 10.6693L17.6016 11.6693L22.0596 14.1533C22.3956 14.3413 22.6396 14.6493 22.7456 15.0193C22.8516 15.3913 22.8056 15.7813 22.6176 16.1173L22.2876 16.7113C22.0336 17.1693 21.5496 17.4533 21.0256 17.4533C20.7816 17.4533 20.5376 17.3893 20.3236 17.2713L15.8656 14.7873L15.2876 15.8233L15.6416 16.0213L15.2516 16.7213H16.9176V17.7973H17.9016V20.4733L17.8976 20.4693ZM7.25156 20.0693H17.4976V18.1933H16.5136V17.1173H14.5676L15.0936 16.1733L14.7396 15.9753L15.7056 14.2413L20.5136 16.9213C20.6696 17.0073 20.8436 17.0533 21.0216 17.0533C21.3996 17.0533 21.7496 16.8473 21.9336 16.5173L22.2636 15.9233C22.3996 15.6793 22.4316 15.3973 22.3556 15.1293C22.2796 14.8613 22.1036 14.6393 21.8596 14.5033L17.0516 11.8233L17.9976 10.1253L18.3516 10.3233L19.0836 9.01134L13.3576 5.82134L12.6256 7.13334L12.9776 7.32934L9.71756 13.1793L9.36356 12.9833L8.63156 14.2973L13.6936 17.1173H8.23156V18.1933H7.24756V20.0693H7.25156Z",
    fill: "#004C3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1143 18.5955V17.5195H8.63634V18.5955H7.65234V19.6715H17.0983V18.5955H16.1143Z",
    fill: "#004C3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBid);
export default __webpack_public_path__ + "static/media/MyBid.e19428d6756d9d67d47749f9a262832a.svg";
export { ForwardRef as ReactComponent };